import { useState, useEffect, useRef } from "react";
import { Modal, initMDB } from "mdb-ui-kit";
import React from 'react';
import AutocompleteAdress from './Autocomplete';
import '@geoapify/geocoder-autocomplete/styles/minimal.css';
import {
    MDBInput,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCheckbox,
    MDBSwitch,
    MDBTextArea,
    MDBFile,
    MDBRadio,
    MDBValidationItem,
    MDBInputGroup,
    MDBBtn,
} from 'mdb-react-ui-kit';
import Coverings from "./Coverings";
import Gutters from "./Gutters";
import RoofExtensions from "./RoofExtensions";

initMDB({ Modal });


const Step = (props) => {

    switch (props.step.number) {
        case 2:
            return (<StepProjectDocumentation {...props} />);
        case 3:
            return (<StepCoverings {...props} />);
        case 4:
            return (<StepExtensions {...props} />);
        case 5:
            return (<StepGutters {...props} />);
        case 6:
            return (<StepIsolation {...props} />);
        case 7:
            return (<StepContactForm {...props} />);
        case 8:
            return (<StepGdpr {...props} />);
        default:
            return (<div>Step error (default) </div>);
    }
};

export default Step;



const StepProjectDocumentation = (props) => {
    const [files, setFiles] = useState();
    const [filesNote, setFilesNote] = useState("");
    const didMount = useRef(false);


    const fileNamesClass = (files) ? "" : " d-none";
    const fileNames = [];
    var fileSize = 0;
    var fileSizeInMb = 0;

    if (files) {
        Array.from(files).forEach(file => {
            file.typ = 'dokumentace';
            //var filename = file.name.normalize();
            //file.name = filename;
            fileNames.push(file.name);
            fileSize += file.size;
        })
        fileSizeInMb = (fileSize / (1024 * 1024)).toFixed(2);
    }

    // TODO omezit fileType souboru
    function validateFileSize() {
        if (fileSize >= 20000000) {
            let fileInput = document.getElementById('documentationFiles');
            fileInput.value = "";
            fileInput.setCustomValidity('Moc velká velikost souborů, vyberte méně souborů');
            fileInput.reportValidity();
            setFiles();
        }
        return true;
    }

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        if (validateFileSize()) { props.step.data = { files, filesNote, fileSize } }
    }, [[files], [filesNote]])


    return (
        <div className="my-5">
            <h6 className='text-uppercase fw-bold text-center'>Zadejte soubory s dokumentací</h6>
            <MDBCol size='12' lg='8' offsetLg='2'>
                <div id='documentationFilesLabel' className='form-text'>
                    (Můžete vybrat více souboru, celková velikost souborů může být maxmálně 20MB)
                </div>
                <MDBFile id='documentationFiles' multiple className='my-2'
                    onChange={(e) => { setFiles(e.target.files) }} />
                <MDBRow className={'form-text' + fileNamesClass}>
                    <div>Náhrané soubory ({fileSizeInMb + "MB"}):
                        {fileNames?.map((fileName, i) => (
                            <span key={fileName} className=''> {i + 1 + ') "' + fileName}"</span>
                        ))}
                    </div>
                </MDBRow>
            </MDBCol>

            {/*<MDBCol size="12" lg='8' offsetLg='2' className="mt-4">*/}
            {/*    <MDBTextArea label='Poznámka' id='documentationNote' rows={4} onChange={(e) => { setFilesNote(e.target.value) }} />*/}
            {/*</MDBCol>*/}
        </div>
    );
}





const StepCoverings = (props) => {
    const [popular, setPopular] = useState(false);

    function extensionsHandler(e) {
        props.stateHandler("extensions", e.target.checked);
    }

    return (
        <div>
            <Coverings popularOnly={popular} {...props} />
            <MDBRow className='mt-5'>
                <MDBSwitch id='extensions' name='extensions' defaultChecked={popular}
                    label='Chci další volitelné střešní doplňky'
                    onClick={(e) => { extensionsHandler(e); }} />
            </MDBRow>
        </div>
    )
}





const StepExtensions = (props) => {
    return (
        <RoofExtensions {...props} />
    );
}





const StepGutters = (props) => {
    return (
        <Gutters {...props} />
    )
}





const StepIsolation = (props) => {
    const didMount = useRef(false);

    // Object of "izolace"
    const [izolace, setIzolace] = useState({
        "rozpisPrvku": true,
        "izolaceTyp": "kompakt",
        "izolaceTloustka": 0,
        "zatepleniPresahu": true,
        "servisniPosouzeniTepelneOchrany": false,
        "konstrukcniVrstvy": [
            {
                "poradi": 0,
                "nazev": "",
                "tloustka": "",
                "miNeboSd": "",
                "lambda": ""
            }
        ],
        "osovaRoztecKrokvi": "",
        "sirkaKrokvi": "",
        "poznamka": "",
        "servisniPosouzeniPripevnovacichVrutu": false,
        "vrutyIzolaceTloustka": "",
        "strechaTvar": "",
        "strechaPlocha": "",
        "strechaSklon": "",
        "vyskaBudovy": "",
        "modelStresnichTasek": "",
        "delkaKrokvi": "",
        "kontralatePrurez": "",
        "kontralateDelka": "",
        "bedneni": false,
        "bedneniMaterial": "",
        "bedneniMm": "",
        "vrutyPoznamka": ""
    });

    // CONSTANTS
    const imgHref = '../prilohy/cenovanabidka/';
    const WIDTHS = {
        basic: [120, 140, 160, 180],
        basicALU: [140, 160, 180, 200],
        kompakt: [120, 140, 160, 180],
        top: [140, 160, 180, 200],
        climaComfort: [60, 80, 100, 120, 140],
    }
    const CONDUCTIVITY = {
        basic: 'λ=0,024 W/mK',
        basicALU: 'λ=0,022 W/mK',
        kompakt: 'λ=0,024 W/mK',
        top: 'λ=0,022 W/mK',
        climaComfort: 'λ=0,021 W/mK',
    }
    const ISOLATION_NOTES = {
        basic: [
            'Rekonstrukce: 80mm vrstva staré minerální vlny, uzavřená vrstva vzduchu, 120mm BramacTherm Basic, hodnotou součinitele prostupu tepla U=0,15W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi',
            'Rekonstrukce: stará minerální vrstva odstraněna, 140mm BramacTherm Basic, hodnotou součinitele prostupu tepla U=0,16W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi'
        ],
        basicALU: ['Novostavby: 140mm BramacTherm Basic ALU, shora opatřen fólií pro doplňkovou hydroizolaci (např. UNI 2S Resistant), hodnota součinitele prostupu tepla U = 0,15 W/m2K, parotěsná vrstva (např. parotěsná fólie Membran 100 2S) na bednění přes viditelné krokve'],
        kompakt: [
            'Rekonstrukce: 80mm vrstva staré minerální vlny, uzavřená vrstva vzduchu, 120mm BramacTherm Kompakt, hodnotou součinitele prostupu tepla U=0,15W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi',
            'Rekonstrukce: stará minerální vrstva odstraněna, 140mm BramacTherm Kompakt, hodnotou součinitele prostupu tepla U=0,16W/m2K, vzduchotěsná vrstva Bramac Uni 2S nad krokvemi'
        ],
        top: [
            'Novostavby: 140mm BramacTherm Top, hodnotou součinitele prostupu tepla U=0,15W/m2K, parotěsná/vzduchotěsná vrstva (např. Bramac Membran 100) na bednění přes viditelné krokve',
            'Novostavby: 140mm BramacTherm Top, hodnotou součinitele prostupu tepla U=0,15W/m2K, parotěsná/vzduchotěsná vrstva (např. Bramac Membran 100) pod krokvemi'
        ],
        climaComfort: [],
    }

    const rozpisPrvkuClass = (
        izolace.izolaceTloustka != ""
        && WIDTHS[izolace.izolaceTyp].includes(izolace.izolaceTloustka)
    ) ? "" : " d-none";


    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = izolace;
            return;
        }
        if (!WIDTHS[izolace.izolaceTyp].includes(izolace.izolaceTloustka)) {
            //izolace.izolaceTloustka = WIDTHS[izolace.izolaceTyp][0];
            izolace.izolaceTloustka = 0;
        }
        props.step.data = izolace;
    }, [izolace])


    let emptyRoofLayers = (izolace.konstrukcniVrstvy.length >= 10) ? izolace.konstrukcniVrstvy : [];
    if (emptyRoofLayers.length <= 1) {
        for (let i = 1; i <= 10; i++) {
            const obj = {
                "poradi": i,
                "nazev": "",
                "tloustka": "",
                "miNeboSd": "",
                "lambda": ""
            }
            emptyRoofLayers.push(obj);
        }
    }

    //Variables for html className, to show or hide elements
    let showRozpisPrvku = (izolace.rozpisPrvku) ? "" : "d-none";
    let showSkladbaStrechy = (izolace.servisniPosouzeniTepelneOchrany) ? "" : "d-none";
    let btnColor = "secondary";


    function handleLayers(row, element) {
        row[element.target.id] = element.target.value;
        setIzolace({ ...izolace, konstrukcniVrstvy: emptyRoofLayers });
    }


    function validateCm(elementId) {
        let element = document.getElementById(elementId);
        element.setCustomValidity('');
        if (!element.checkValidity()) {
            element.setCustomValidity('Zadejte pouze číslo');
        }
        element.reportValidity();
    }
    function primaryColorByBool(value) {
        return value ? ' c-primary ' : ' ';
    }


    return (
        <div>
            <MDBContainer>
                <MDBRow className='pb-2'>
                    <MDBRow className='mb-3'>
                        <MDBCol className='align-content-end'>
                            <h5 className='text-uppercase'>Plánovaná celoplošná izolace BramacTherm</h5>
                        </MDBCol>
                        <MDBCol>
                            <MDBBtn color='primary' className='float-end' onClick={() => {
                                document.getElementById('Isolation').click();
                            }}>Zrušit BramacTherm</MDBBtn>
                        </MDBCol>
                    </MDBRow>
                    <MDBCol size='12' lg="5">

                        <MDBRow className="mt-3">
                            <MDBCol size='6' className='d-grid gap-2'>
                                <h6>Zvolte typ:</h6>
                                <MDBRadio btn btnColor={btnColor} id='basic' name='izolaceTyp' label='Basic' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'basic')} value='basic'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='basicALU' name='izolaceTyp' label='Basic Alu' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'basicALU')} value='basicALU'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='kompakt' name='izolaceTyp' label='Kompakt' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'kompakt')} value='kompakt'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='top' name='izolaceTyp' label='Top' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'top')} value='top'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                                <MDBRadio btn btnColor={btnColor} id='climaComfort' name='izolaceTyp' label='Clima Comfort' wrapperClass='izolace-radio'
                                    defaultChecked={(izolace.izolaceTyp === 'climaComfort')} value='climaComfort'
                                    onClick={(e) => { setIzolace({ ...izolace, [e.target.name]: e.target.value }) }}
                                />
                            </MDBCol>
                            <MDBCol size="5" offsetMd='1' className='d-grid gap-2'>
                                <h6>Zvolte tloušťku:</h6>
                                {WIDTHS[izolace.izolaceTyp].map((width) => (
                                    <MDBRadio key={izolace.izolaceTyp + width} name='width' id={width} value={width} label={width + " mm"} inline checked={(width == izolace.izolaceTloustka)}
                                        onChange={() => { setIzolace({ ...izolace, izolaceTloustka: width }) }} />
                                ))}
                                <p className="small mt-2">{CONDUCTIVITY[izolace.izolaceTyp]}</p>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    <MDBCol size='12' lg="7">
                        <MDBRow className='isolation-images mt-2'>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_view_" + izolace.izolaceTyp + ".jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_" + izolace.izolaceTyp + "_1.jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                            <MDBCol size='4'>
                                <img
                                    src={imgHref + "isolation/bramactherm_" + izolace.izolaceTyp + "_2.jpg"}
                                    className="img-fluid"
                                    alt=""
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='mt-2'>
                            {ISOLATION_NOTES[izolace.izolaceTyp]?.map((note, i) => (
                                <MDBCol key={izolace.izolaceTyp + "note" + i}>
                                    <p className="extra-small">
                                        {note}
                                    </p>
                                </MDBCol>
                            ))}
                        </MDBRow>
                        <MDBRow>
                            <p className='mt-3 extra-small fst-italic'>
                                Pozn.: Uvedené skladby střešního pláště jsou pouze orientační, existuje mnoho dalších variant.
                            </p>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>


                <div key='rozpisPrvku' className={rozpisPrvkuClass}>
                    <MDBRow className="mt-5">
                        <MDBSwitch id='rozpisPrvku' defaultChecked={izolace.rozpisPrvku}
                            label='Rozpis prvků a cenová nabídka'
                            labelClass={'fs-4 ' + primaryColorByBool(izolace.rozpisPrvku)}
                            wrapperClass='d-flex align-items-center small'
                            onClick={() => { setIzolace({ ...izolace, rozpisPrvku: !izolace.rozpisPrvku }); }} />
                        <MDBRow className={showRozpisPrvku} >
                            <MDBSwitch id='zatepleni' defaultChecked={izolace.zatepleniPresahu}
                                label='Zateplení přesahů střechy' wrapperClass='mt-2 d-flex align-items-center' className='ms-4 extra-small'
                                onClick={(e) => { setIzolace({ ...izolace, zatepleniPresahu: !izolace.zatepleniPresahu }); }} />
                        </MDBRow>
                    </MDBRow>

                    <MDBRow className="mt-4">
                        <MDBSwitch id='skladbaStrechyCheck' defaultChecked={izolace.servisniPosouzeniTepelneOchrany}
                            label='Servisní posouzení tepelné ochrany a šíření vlhkosti'
                            labelClass={'fs-4 ' + primaryColorByBool(izolace.servisniPosouzeniTepelneOchrany)}
                            wrapperClass='d-flex align-items-center small'
                            onClick={(e) => { setIzolace({ ...izolace, servisniPosouzeniTepelneOchrany: !izolace.servisniPosouzeniTepelneOchrany }); }} />
                        <p>
                            Pro BramacTherm - celoplošnou tepelnou izolaci nad krokvemi, nabízí firma Bramac servisní posouzení.
                            Výsledkem posouzení bude prokázána dostatečná tepelná ochrana (součinitel prostupu tepla U)
                            a ochrana před kondenzací zadané střešní skladby.
                        </p>
                    </MDBRow>

                    <MDBContainer className={showSkladbaStrechy + " mt-4"}>
                        <h5>Skladba střechy </h5>
                        <p>konstrukční vrstvy v interiéru (od vnitřního obložení) směrem ven (až po krytinu) včetně vzduchových mezer:</p>
                        <MDBRow className="my-3">
                            <MDBCol size="8" lg='4' className='mt-2'>
                                <MDBInputGroup textAfter='cm'>
                                    <MDBInput id='roofCompPitch' label='Osová rozteč krokví' type='text' value={izolace.osovaRoztecKrokvi}
                                        pattern="[0-9,.]+" maxLength="5" required noValidate
                                        onChange={(e) => { setIzolace({ ...izolace, osovaRoztecKrokvi: e.target.value }); validateCm(e.target.id); }} />
                                </MDBInputGroup>
                            </MDBCol>
                            <MDBCol size="8" lg='4' className='mt-2'>
                                <MDBInputGroup textAfter='cm'>
                                    <MDBInput id='roofCompWidth' label='Šířka krokví' type='text' value={izolace.sirkaKrokvi}
                                        pattern="[0-9,.]+" maxLength="5" required noValidate
                                        onChange={(e) => { setIzolace({ ...izolace, sirkaKrokvi: e.target.value }); validateCm(e.target.id) }} />
                                </MDBInputGroup>
                            </MDBCol>
                        </MDBRow>

                        <div>
                            <MDBRow>
                                <MDBCol size="3">
                                    <p>Konstrukční vrstva</p>
                                </MDBCol>
                                <MDBCol size="3">
                                    <p>Tloušťka[mm]</p>
                                </MDBCol>
                                <MDBCol size="3">
                                    <p>µ nebo Sd[mm]</p>
                                </MDBCol>
                                <MDBCol size="3">
                                    <p>λ[W/mK]</p>
                                </MDBCol>
                            </MDBRow>
                            {emptyRoofLayers.map(row => (
                                <MDBRow className="mt-2" key={"vrstva" + row.poradi}>
                                    <MDBCol size="3">
                                        <MDBRow>
                                            <MDBCol size="1">
                                                <p>{row.poradi}</p>
                                            </MDBCol>
                                            <MDBCol>
                                                <MDBInput id={"nazev"} name={row.poradi + "nazev"} type='text'
                                                    onBlur={(e) => { handleLayers(row, e) }} />
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                    <MDBCol size="3">
                                        <MDBInput id={"tloustka"} name={row.poradi + "tloustka"} type='text' onBlur={(e) => { handleLayers(row, e) }} />
                                    </MDBCol>
                                    <MDBCol size="3">
                                        <MDBInput id={"miNeboSd"} name={row.poradi + "miNeboSd"} type='text' onBlur={(e) => { handleLayers(row, e) }} />
                                    </MDBCol>
                                    <MDBCol size="3">
                                        <MDBInput id={"lambda"} name={row.poradi + "lambda"} type='text' onBlur={(e) => { handleLayers(row, e) }} />
                                    </MDBCol>
                                </MDBRow>
                            ))}
                            <MDBRow className='mt-2'>
                                <p>Příklad: 1 sádrokarton 12,5 mm, 2 laťování 24 mm, 3 krokev 140mm, 4 minerální vlna 40 mm/λ=0,040 W/mK,
                                    5 vzduchová vrstva 100 mm, 6 bednění 24 mm, 7 vzduchotěsná/parotěsná vrstva Sd=100 mm,
                                    8 BramacTherm Top 120 mm, 9 kontralatě/střešní latě/střešní tašky</p>
                            </MDBRow>
                        </div>

                        <MDBRow className="mt-4">
                            <MDBCol>
                                <MDBTextArea label='Poznámka' id='roofCompositionNote' rows={4}
                                    onChange={(e) => { setIzolace({ ...izolace, poznamka: e.target.value }); }} />
                            </MDBCol>
                        </MDBRow>
                        <p>
                            Pozn.: Servisní posouzení bude provedeno podle Vámi zadaných údajů podle nejlepšího vědomí a svědomí.
                            Z něj vyplývající výsledky nemají však žádnou právní závaznost.
                            Doporučení nezbavují případné povinnosti posouzení oprávněnou osobou.
                        </p>
                    </MDBContainer>
                </div>
            </MDBContainer>
        </div>
    );
}





const StepContactForm = (props) => {
    const didMount = useRef(false);
    //Input data
    const [objectImage, setObjectImage] = useState();
    const [formData, setFormData] = useState({
        kontakt: {
            typZadavatele: ""
        },
        stavba: {
            obec: "",
            ulice: "",
            investor: "",
            prilohyGps: [],
            prilohyDokumentace: [],
            budovy: [{
                poradi: 0,
                adresa: "",
                ulice: "",
                obec: "",
                psc: "",
                okres: "",
                zemSirka: "",
                zemDelka: ""
            }],
        }
    });

    //Behaviour of form
    const [objImgChecked, setObjImgChecked] = useState(false);
    const objImgDisplay = (objImgChecked) ? "" : " d-none";
    const mapDisplay = props.step.showMap;
    const [mapUpdate, setMapUpdate] = useState(false);
    const stavbaUdaje = !(formData.kontakt.typZadavatele === "" || formData.kontakt.typZadavatele === "Investor / koncový zákazník");

    useEffect(() => {
        //formData.stavba.budovy = [
        //    {
        //        "poradi": 1,
        //        "adresa": formData.stavba.ulice,
        //        "ulice": formData.stavba.ulice,
        //        "obec": formData.stavba.ulice,
        //        "psc": formData.kontakt.psc,
        //        "okres": "",
        //        "zemSirka": "",
        //        "zemDelka": ""
        //    }
        //];
        if (!didMount.current) {
            didMount.current = true;
            props.step.data = { formData, objectImage }
            return;
        }

        formData.stavba.budovy[0].poradi = 1
        formData.stavba.budovy[0].adresa = formData.stavba.ulice + ", " + formData.stavba.obec + " " + formData.stavba.psc
        formData.stavba.budovy[0].ulice = formData.stavba.ulice
        formData.stavba.budovy[0].obec = formData.stavba.obec
        formData.stavba.budovy[0].psc = formData.stavba.psc

        setMapUpdate(true);
        props.step.data = { formData, objectImage }
    }, [[formData], [objectImage]])

    function validatePSC(id) {
        document.getElementById(id).reportValidity();
    }

    function setAddressFromMap(address) {
        if (address == undefined) return;
        const addrArr = address.split(",");

        let stavbaUpdate = formData.stavba;
        stavbaUpdate.ulice = addrArr[0];
        stavbaUpdate.obec = addrArr[1];
        stavbaUpdate.psc = addrArr[2];
        stavbaUpdate.budovy = [{
            "okres": "",
            "zemSirka": addrArr[3],
            "zemDelka": addrArr[4]
        }]
        setFormData({ ...formData, stavba: stavbaUpdate })
    }

    function stavbaUdajeDiv() {
        return (stavbaUdaje) ? (
            <div className={"mt-4"}>
                <h5>Údaje o stavbě:</h5>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněno jméno stavebníka">
                        <MDBInput id="builderName" label="Jméno stavebníka" required={stavbaUdaje} maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, investor: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněn telefon na stavebníka">
                        <MDBInput className="mt-3" id="builderTel" label="Telefon na stavebníka" required={stavbaUdaje} maxLength="50"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, telefon: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
            </div>
        ) : (
            <div></div>
        );
    }

    function stavbaAddress() {
        return mapDisplay ? (
            <div>
                <h5 className="m-0">Lokalita stavby:</h5>
                <div className='form-text my-2'>
                    Napište adresu objektu a potom na mapě <b>označte objekt levým tlačítkem myši</b>.
                    Místo můžete upřesnit dalším kliknutím do mapy.
                </div>
                <AutocompleteAdress handler={setAddressFromMap} mapUpdate={mapUpdate} />
            </div>
        ) : (
            <div>
                <h5 className="mb-3">Lokalita stavby:</h5>
                <MDBRow>
                    <MDBValidationItem invalid feedback="Není vyplněna ulice stavby">
                        <MDBInput id="stavbaUlice" label="Ulice, č.p." required maxLength="200"
                            onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, ulice: e.target.value } }) }} />
                    </MDBValidationItem>
                </MDBRow>
                <MDBRow className="mt-3">
                    <MDBCol>
                        <MDBValidationItem invalid feedback="Není vyplněna obec stavby">
                            <MDBInput id="stavbaObec" label="Obec" required maxLength="200"
                                onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, obec: e.target.value } }) }} />
                        </MDBValidationItem>
                    </MDBCol>
                    <MDBCol>
                        <MDBValidationItem invalid feedback="Není vyplněno PSČ stavby">
                            <MDBInput id="pscStavba" label="PSČ" required pattern="[0-9]{5}" maxLength="5"
                                onChange={(e) => {
                                    setFormData({ ...formData, stavba: { ...formData.stavba, psc: e.target.value } }, validatePSC('pscStavba'));
                                }} />
                        </MDBValidationItem>
                    </MDBCol>
                </MDBRow>
            </div>
        );
    }

    function photoOfBuilding() {
        return (mapDisplay) ? (
            <div className="mt-3">
                <MDBCheckbox
                    id='objectImageCheck'
                    label='Fotografie objektu (nepovinné – slouží k lepší identifikaci objektu)'
                    defaultChecked={objImgChecked}
                    onChange={() => setObjImgChecked(!objImgChecked)}
                />
                <MDBFile id='objectImage' onChange={(e) => { setObjectImage(e.target.files) }} className={objImgDisplay} />
            </div>
        ) : (<div></div>);
    }

    return (
        <div>
            <form id="kontaktForm">
                <div>
                    <h5>Jsem:</h5>
                    <MDBRadio name='customerType' id='Investor / koncový zákazník' label='Stavebník / Koncový zákazník'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Obchodník' label='Obchodník'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Realizační firma / pokrývač' label='Pokrývač / Realizační firma'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBRadio name='customerType' id='Architekt / projektant' label='Architekt / Projektant'
                        onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    <MDBValidationItem invalid feedback="Není vybráno Vaše zaměření">
                        <MDBRadio name='customerType' id='Jiné' label='Oblastní zástupce Bramac' required
                            onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, typZadavatele: e.target.id } }) }} />
                    </MDBValidationItem>
                </div>

                <div className="mt-4">
                    <h5>Odesílatel:</h5>
                    <MDBRow className="my-3">
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadáno jméno odesílatele">
                                <MDBInput id="jmeno" label="Jméno" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, jmeno: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadáno příjmení odesílatele">
                                <MDBInput id="prijmeni" label="Příjmení" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, prijmeni: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBValidationItem invalid feedback="Není zadána ulice adresy odesílatele">
                            <MDBInput id="ulice" label="Ulice, č.p." required maxLength="200"
                                onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, ulice: e.target.value } }) }} />
                        </MDBValidationItem>
                    </MDBRow>
                    <MDBRow className="my-3">
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadána obec adresy odesílatele">
                                <MDBInput id="obec" label="Obec" required maxLength="200"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, obec: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                        <MDBCol>
                            <MDBInput id="pscKontakt" label="PSČ" required pattern="[0-9]{5}" maxLength="5"
                                onChange={(e) => {
                                    setFormData({ ...formData, kontakt: { ...formData.kontakt, psc: e.target.value } }, validatePSC('pscKontakt'));
                                }} />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="my-3">
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadán telefon odesílatele">
                                <MDBInput id="telefon" label="Telefon" type="tel" required maxLength="50"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, telefon: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                        <MDBCol>
                            <MDBValidationItem invalid feedback="Není zadán e-mail odesílatele">
                                <MDBInput id="email" label="Email" type="email" required maxLength="100"
                                    onChange={(e) => { setFormData({ ...formData, kontakt: { ...formData.kontakt, email: e.target.value } }) }} />
                            </MDBValidationItem>
                        </MDBCol>
                    </MDBRow>
                </div>

                {stavbaUdajeDiv()}

                <div className={"mt-4"}>
                    {stavbaAddress()}
                    {photoOfBuilding()}
                    <MDBTextArea label='Poznámka' id='buildingNote' rows={6} className="mt-3"
                        onChange={(e) => { setFormData({ ...formData, stavba: { ...formData.stavba, poznamka: e.target.value } }) }} />
                </div>
            </form>
        </div>
    );
}





const StepGdpr = (props) => {

    return (
        <div>
            <MDBContainer>
                <p className='mb-3'>
                    Zaškrtnutím pole „Souhlas se zpracováním osobních údajů“ jako subjekt údajů uděluji tímto společnosti BMI
                    střešní a hydroizolační systémy s.r.o., se sídlem Prosecká 855/68, 190 00 Praha 9, IČ: 15052346,
                    kontaktní e-mail: <a href="mailto:bramac.cz@bmigroup.com" className="c-primary">bramac.cz@bmigroup.com</a>,
                    (dále jen Správce), dobrovolný a svobodný souhlas, aby Správce na základě tohoto souhlasu shromažďoval,
                    uchovával a zpracovával mé osobní údaje, a to za níže uvedených podmínek:
                </p>
                <ol>
                    <li>Osobní údaje, které budou zpracovány jsou: jméno a příjmení, adresa bydliště, telefonický kontakt, e-mailový kontakt, adresa stavby</li>
                    <li>Poskytnutí osobních údajů není zákonným požadavkem Správce</li>
                    <li>Subjekt údajů poskytuje osobní údaje dobrovolně ke zpracování pouze k následujícím účelům:</li>
                    <ol className="souhlas1 mb-2">
                        <li>ke zpracování cenové nabídky dodávky střešní krytiny a příslušenství z portfolia značky BMI BRAMAC ze strany Správce, kterou si  vyžádal  subjekt údajů</li>
                        <li>pro marketingové účely</li>
                    </ol>
                    <li>Osobní údaje nebudou předávány třetím osobám a do třetích zemí</li>
                    <li>Zpracování osobních údajů subjektu údajů bude manuální a automatizované</li>
                    <li>Práva subjektu údajů:</li>
                    <ol className="souhlas1 mb-2">
                        <li>právo kdykoliv odvolat v celém rozsahu svůj souhlas se zpracováním osobních údajů, a to písemnou nebo elektronickou formou (zahrnuje rovněž právo odvolat souhlas se zpracováním osobních údajů pouze k některým účelům, které jsou uvedeny v odst. 3 tohoto souhlasu)</li>
                        <li>právo požadovat od Správce přístup ke svým osobním údajům, jejich opravu nebo výmaz, popřípadě omezení zpracování, a vznést námitku proti zpracování</li>
                        <li>právo na přenositelnost těchto údajů k jinému správci</li>
                        <li>právo podat stížnost dozorovému orgánu, jímž je  Úřad pro ochranu osobních údajů</li>
                    </ol>
                    <li>Souhlas dle tohoto odstavce se uděluje na dobu  maximálně 10 let od jeho udělení</li>
                    <li>Subjekt údajů potvrzuje, že výše uvedenému poučení rozumí a že  poskytnuté  osobní údaje jsou přesné a pravdivé</li>
                </ol>
            </MDBContainer>
        </div>
    );
}

